import { render } from "./CampaignResults.vue?vue&type=template&id=0f1a0250&ts=true"
import script from "./CampaignResults.vue?vue&type=script&lang=ts"
export * from "./CampaignResults.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__